module.exports = __webpack_public_path__ + "static/oath-3f3b7fe6f324346afc9f9cc81a4a1538.svg";